import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useNotificationContext } from "../../common/NotificationContext";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import {
  PartTypeListingService,
  ActionsListingService,
  spareStatusListingService,
  onAddSpareService,
  onEditSpareService,
  fetchSpareDetailsByIdService,
  VendorListingService,
} from "../../services/SpareSearchService";
import {
  Select,
  MenuItem,
  Button,
  TextField,
  Grid,
  Box,
  FormControl,
  InputLabel,
  Typography,
  IconButton,
  ListItemText,
  Checkbox,
  OutlinedInput,
  FormHelperText,
  Autocomplete
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useForm } from "react-hook-form";
import useGlobalState from "../../Context";
import { de } from "date-fns/locale";

const AddEditSpare = (props) => {
  const { onClearClick } = props;
  const { showNotification } = useNotificationContext();
  const [formData, setFormData] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [warrantyValue, setWarrantyValue] = useState(null);
  const [spareId, setSpareId] = useState(null);
  const [partTypeList, setPartTypeList] = useState([]);
  const [actionList, setActionList] = useState([]);
  const [spareStatusList, setSpareStatusList] = useState([]);
  
  const [vendorsList, setVendorsList] = useState([]);
  const [suppliersList, setSupplierList] = useState([]);
  const [spareActionId, setSpareAcionId] = useState(null);
  const [vendorName, setVendorName] = useState([]);
  const [suppliersName, setSuppliersName] = useState([]);
  const [spStatus, setSpStatus] = useState();
  const [supplierACode, setSupplierACode] = useState([]);
  const [vendors, setVendors] = useState(null);
  const [suppliers, setSuppliers] = useState(null);
  const [sendNotification, setSendNotification] = React.useState(false);
  const [{ auth }, dispatch] = useGlobalState();
  const [typeValue, setTypeValue] = useState('');
  const [typeValueId, setTypeValueId] = useState(null);
  const loggedInUserInfo = auth.ldapParam;
  console.log("loggedInUserInfo", loggedInUserInfo);
  const formOption = {
    // resolver: yupResolver(ADD_SPARE_VALIDATIONS),
    defaultValues: { ...formData },
  };
  const { register, handleSubmit, formState, reset, setValue } =
    useForm(formOption);
  const { errors } = formState;
  const [formValues, setFormValues] = useState({
    createdOn: new Date(),
    createdBy: auth?.ldapParam?.userId,
    modifiedBy: null,
  });
  useEffect(() => {
    // fetchStatusList();
    if (!isEditMode) {
      fetchPartTypeList();
      fetchActionsList();
     fetchSpareStatus();
    }
  }, []);
  const navigate = useNavigate();
  const { state } = useLocation();
  const goBack = () => {
    if(state?.fromModel){
      navigate("/model-search/model-view",{state:{modelId: state.model_id,brandName: state?.brand_name,
        modelCode: state?.model_code,}});
    }
    else{
      // onClearClick()
      navigate("/spare-search");
    }
   };

  useEffect(() => {
    reset(formData);
  }, []);

  const fetchPartTypeList = async () => {
    try {
      const partTypeListingResponse = await PartTypeListingService();
      if (partTypeListingResponse.statusCode === 6) {
        setPartTypeList(partTypeListingResponse.data);
      } else {
        showNotification("Error", partTypeListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchActionsList = async () => {
    try {
      const actionsListingResponse = await ActionsListingService();
      if (actionsListingResponse.statusCode === 6) {
        setActionList(actionsListingResponse.data);
      } else {
        showNotification("Error", actionsListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };
  const fetchSpareStatus = async () => {
    try {
      const spareStatusListingResponse = await spareStatusListingService();
      if (spareStatusListingResponse.statusCode === 6) {
        setSpareStatusList(spareStatusListingResponse.data);
      } else {
        showNotification("Error", spareStatusListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const onAddEditSpareSubmit = async (data) => {
    try {
      // var d = new Date();
      // d.setHours(0,0,0,0);
      // if(warrantyValue < d){
      //   showNotification("Error", "Please select valid date", "error");
      //   return
      // }
      let addObj = {
        code: data.code ? data.code.trim():null,
        shortName: data.shortName ? data.shortName.trim() : "",
        description: data.description ? data.description.trim() : "",
        name: data.name ? data.name.trim() : "",
        billingPR: data.billingPR ?? "",
        retailPR: data.retailPR ?? "",
        partTypeId: typeValueId ?? null,
        defSpareActionId: data.defSpareActionId ?? null,
        warranty: data.warranty?? "",
        spec: data.spec ? data.spec.trim() : null,
        dimension: data.dimension ? data.dimension.trim() : "",
        packInfo: data.packInfo ? data.packInfo.trim() : "",
        appInstall: data.appInstall ? data.appInstall.trim() : "",
        spCare: data.spCare ? data.spCare.trim() : "",
        createdOn: formValues.createdOn,
        createdBy: formValues.createdBy,
        modifiedOn: null,
        modifiedBy: formValues.modifiedBy,
        active: data.active,
        vendorIds: vendors,
        supplierIds: suppliers,
        sendNotification,
        shortDesc: data.shortDesc ? data.shortDesc.trim(): "",
        createdByName: loggedInUserInfo.name,
        supplierAcode: data.spareAcode ? data.spareAcode.trim() : "",
        spareStatus: data.spareStatus ? data.spareStatus : "",
      };
      let editObj = {
        code: formData.code ? formData.code.trim() : null,
        shortName: data.shortName ? data.shortName.trim() : "",
        description: data.description ? data.description.trim() : "",
        name: data.name ? data.name.trim() : "",
        billingPR: data.billingPR ?? "",
        retailPR: data.retailPR ?? "",
        partTypeId: typeValueId ?? null,
        defSpareActionId: data.defSpareActionId ?? null,
        warranty: data.warranty ?? "",
        spec: data.spec ? data.spec.trim() : null,
        dimension: data.dimension ? data.dimension.trim() : "",
        packInfo: data.packInfo ? data.packInfo.trim() : "",
        appInstall: data.appInstall ? data.appInstall.trim() : "",
        spCare: data.spCare ? data.spCare.trim() : "",
        createdOn: formData.createdOn,
        createdBy: formData.createdBy,
        modifiedOn: new Date(),
        modifiedBy: loggedInUserInfo.userId,
        spareId,
        active: data.active ?? formData.active,
        vendorIds: vendors,
        supplierIds: suppliers,
        sendNotification,
        shortDesc: data.shortDesc ? data.shortDesc.trim() : null,
        createdByName: loggedInUserInfo.name,
        modifiedByName: loggedInUserInfo.name,
        supplierAcode: data.spareAcode ? data.spareAcode.trim() : "",
        spareStatus: data.spareStatus ? data.spareStatus : "",
      };
      const res = !isEditMode
        ? await onAddSpareService(addObj)
        : await onEditSpareService(editObj);
      if (res.statusCode === 6) {
        showNotification("Success", res.message, "success");
        navigate("/spare-search");
        onClearClick();
      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (err) {
      throw err;
    }
  };
  const fetchSpareById = async (id) => {
    try {
      const res = await fetchSpareDetailsByIdService(id);
      // if (res) {
      //   reset(res);
      // }

      if (res.statusCode == "6") {
        reset(res.data);
        setFormData(res.data);
        setSpareAcionId(res.data.defSpareActionId);
        const vendorIds = res.data.vendorRespList?.map((v) => v.id);
        setVendors(vendorIds);
        setVendorName(
          typeof vendorIds === "string" ? vendorIds.split(",") : vendorIds
        );
        const supplierIds = res.data.supplierList?.map((s) => s.id);
        setSuppliers(supplierIds);
        setSuppliersName(
          typeof supplierIds === "string" ? supplierIds.split(",") : supplierIds
        );
        setWarrantyValue(res.data.warranty);
        setSpStatus(res.data.spareStatus);
        
          setValue("spareStatus", res.data.spareStatus);
        setSupplierACode(res.data.spareAcode);

        setTypeValueId(res.data.partTypeId);
      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };
console.log("setSpStatus", spStatus);
  useEffect(() => {
    setIsEditMode(state?.isEdit);
    setSpareId(state?.id);
    if (state) {
      fetchSpareById(state?.id);
    }
  }, []);

  useEffect(() => {
    fetchVendorSupplierList(spareActionId === 2 ? "VENDORS" : "SUPPLIERS");
  }, [spareActionId]);

  useEffect(() => {
    setValue("defSpareActionId", formData.defSpareActionId);
    setValue("partTypeId", formData.partTypeId);
     setValue("spareStatus", formData.spareStatus);
     setValue("description", formData.description);
      setValue("spareAcode", formData.spareAcode);
      

     
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  const fetchVendorSupplierList = async (type) => {
    try {
      const response = await VendorListingService(type);
      if (response.statusCode == "6") {
        if (type === "VENDORS") {
          setVendorsList(response.data);
          setSupplierList([]);
          setSuppliers(null);
        } else {
          setSupplierList(response.data);
          setVendorsList([]);
          setVendors(null);
        }
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };
  const onSpareActionClick = async (id) => {
    setSpareAcionId(id);
    if (id === 2) {
      await fetchVendorSupplierList("VENDORS");
    } else {
      await fetchVendorSupplierList("SUPPLIERS");
    }
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const onVendorChange = (event) => {
    const {
      target: { value },
    } = event;
    setVendorName(typeof value === "string" ? value.split(",") : value);
    setVendors(event.target.value);
  };

  const onSuppliersChange = (event) => {
    const {
      target: { value },
    } = event;
    setSuppliersName(typeof value === "string" ? value.split(",") : value);
    setSuppliers(event.target.value);
  };

  const onStatusChange = (value) => {
    
    setSpStatus(value);
  };

  // To change the value of send notification checkbox
  const handleChange = (event) => {
    setSendNotification(event.target.checked);
  };

  return (
    <>
      <Grid maxWidth="lg" sx={{ mt: 6 }}>
        <Grid container sx={{ px: 1, mt: 1 }}>
          <Grid item xs={8} sx={{ mb: 1 }}>
            <Typography
              align="left"
              sx={{
                mr: "auto",
                pointer: "cursor",
                color: "#003f93",
                // fontWeight: "bold",
                marginTop: "30px",
              }}
              variant="h6"
            >
              <IconButton sx={{ color: "#003f93" }}>
                <ArrowBackIcon onClick={goBack} />
              </IconButton>
              {isEditMode ? "Edit" : "Add"} Spare
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} md={12}>
          <Grid item xs={12} md={12} sx={{ p: 2 }}>
            <Box>
              <form>
                <Grid container spacing={2} textAlign="left">
                  <Grid item xs={4} sm={4}>
                    <TextField
                      className="stepperFormInput"
                      name="code"
                      label="Article Code"
                      placeholder="Enter article code"
                      fullWidth
                      size="small"
                      required
                      autoComplete="off"
                      disabled={isEditMode && true}
                      InputLabelProps={{ shrink: isEditMode && true }}
                      {...register("code", {
                        required: "This field is required",
                        pattern: {
                          value: /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])[^\n]+$/,
                          message: "Field can not start with special characters",
                        },
                        maxLength: {
                          value: 20,
                          message: "Max length should be 20 only",
                        },
                        minLength: {
                          value: 1,
                          message: "Min length should be 1 only",
                        },
                      })}
                      error={Boolean(errors?.code?.message)}
                      // helperText={errors?.shortDesc?.message}
                      helperText={errors?.code?.message}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <FormControl fullWidth>
                      <InputLabel
                        id="demo-simple-select-label"
                        sx={{ marginTop: !isEditMode ? "-6px": "0px" }}
                      >
                        Spare Action *
                      </InputLabel>
                      <Select
                        className="stepperFormInput"
                        label="Spare Action *"
                        name="defSpareActionId"
                        fullWidth
                       
                        InputLabelProps={{ shrink: isEditMode && true }}
                         required
                        size="small"
                        value={spareActionId || ""}  
                        
                        autoComplete="off"
                     
                        {...register("defSpareActionId", {
                          required: "This field is required",
                        })}
                        error={Boolean(errors?.defSpareActionId)}
                        helperText={errors?.defSpareActionId?.message}
                        onChange={(e) => onSpareActionClick(e.target.value)}  // 
                      >
                        {actionList &&
                              actionList.map((d) => {
                                return (
                                  <MenuItem
                                    native
                                    key={d.defSpareActionId}
                                    sx={{ width: "100%" }}
                                    value={d.defSpareActionId}
                                    size="small"
                                     
                                  >
                                    {d.name}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.spareStatus?.message}
                          </FormHelperText>
                    </FormControl>
                  </Grid>
                  {spareActionId === 2 ? (
                    <Grid item xs={4} sm={4}>
                      <FormControl sx={{ width: "100%" }}>
                        <InputLabel
                          id="demo-multiple-checkbox-label"
                          sx={{ marginTop: "-6px" }}
                        >
                          Select Vendors
                        </InputLabel>
                        <Select
                          labelId="demo-multiple-checkbox-label"
                          id="demo-multiple-checkbox"
                          multiple
                          size="small"
                          value={vendorName}
                          onChange={onVendorChange}
                          input={<OutlinedInput label="Select Vendors" />}
                          // renderValue={(selected) => selected.join(", ")}
                          renderValue={(selected) =>
                            `You have selected ${selected.length} ${selected.length > 1 ? "vendors" : "vendor"
                            } `
                          }
                          MenuProps={MenuProps}
                        >
                          {vendorsList.map((d) => (
                            <MenuItem key={d.vendorId} value={d.vendorId}>
                              <Checkbox
                                checked={vendorName.indexOf(d.vendorId) > -1}
                              />
                              <ListItemText primary={d.name + " -" + d.code} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  ) : null}
                  {spareActionId === 1 ? (
                    <Grid item xs={4} sm={4}>
                      <FormControl sx={{ width: "100%" }}>
                        <InputLabel
                          id="demo-multiple-checkbox-label"
                          sx={{ marginTop: "-6px" }}
                        >
                          Select Suppliers
                        </InputLabel>
                        <Select
                          labelId="demo-multiple-checkbox-label"
                          id="demo-multiple-checkbox"
                          multiple
                          size="small"
                          value={suppliersName}
                          onChange={onSuppliersChange}
                          input={<OutlinedInput label="Select Suppliers" />}
                          // renderValue={(selected) => selected.join(", ")}
                          renderValue={(selected) =>
                            `You have selected ${selected.length} ${selected.length > 1 ? "Suppliers" : "Supplier"
                            } `
                          }
                          MenuProps={MenuProps}
                        >
                          {suppliersList.map((d) => (
                            <MenuItem key={d.vendorId} value={d.vendorId}>
                              <Checkbox
                                checked={suppliersName.indexOf(d.vendorId) > -1}
                              />
                              <ListItemText primary={d.name + " -" + d.code} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  ) : null}
                  <Grid item xs={4} sm={4}>
                    <TextField
                      className="stepperFormInput"
                      name="name"
                      label="Name"
                      placeholder="Enter name"
                      fullWidth
                      size="small"
                     // disabled={isEditMode && true}
                      InputLabelProps={{ shrink: isEditMode && true }}
                      required
                      autoComplete="off"
                      {...register("name", {
                        required: "This field is required",
                        pattern: {
                          value: /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])[^\n]+$/,
                          message: "Field can not start with special characters",
                        },
                        maxLength: {
                          value: 100,
                          message: "Max 100. characters required",
                        },
                        minLength: {
                          value: 3,
                          message: "Minimum 3 characters required",
                        },
                      })}
                      error={errors?.name?.message}
                      helperText={errors?.name?.message}
                      onBlur={(e) => {
                        let str = e.target.value;
                        setValue("name", str.trim());
                       
                      }}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <TextField
                      className="stepperFormInput"
                      name="shortName"
                      label="Short Name"
                      placeholder="Enter short name"
                      fullWidth
                      size="small"
                      //disabled={isEditMode && true}
                      InputLabelProps={{ shrink: isEditMode && true }}
                      required
                      autoComplete="off"
                      {...register("shortName", {
                        required: "This field is required",
                        pattern: {
                          value: /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])[^\n]+$/,
                          message: "Field can not start with special characters",
                        },
                        maxLength: {
                          value: 100,
                          message: "Max 100 characters required",
                        },
                        minLength: {
                          value: 3,
                          message: "Minimum 3 characters required",
                        },
                      })}
                      error={errors?.shortName?.message}
                      helperText={
                        errors?.shortName?.message
                      }
                      onBlur={(e) => {
                        let str = e.target.value;
                        setValue("shortName", str.trim());
                       
                      }}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <TextField
                      className="stepperFormInput"
                      name="billingPR"
                      label="Billing PR"
                      placeholder="Enter billing"
                      fullWidth
                      size="small"
                      type="number"
                      InputProps={{
                        inputProps: { min: 0 }
                      }}
                      onInput={(event) =>
                        event.target.value < 0
                          ? (event.target.value = "")
                          : event.target.value
                      }
                     // disabled={isEditMode && true}
                      InputLabelProps={{ shrink: isEditMode && true }}
                      required
                      autoComplete="off"
                      {...register("billingPR", { required: true })}
                      error={errors?.billingPR}
                      helperText={
                        errors?.billingPR ? "This field is required" : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <TextField
                      className="stepperFormInput"
                      name="retailPR"
                      label="Retail PR"
                      placeholder="Enter Retail"
                      fullWidth
                      size="small"
                      type="number"
                    //  disabled={isEditMode && true}
                      InputLabelProps={{ shrink: isEditMode && true }}
                      InputProps={{
                        inputProps: { min: 0 }
                      }}
                      onInput={(event) =>
                        event.target.value < 0
                          ? (event.target.value = "")
                          : event.target.value
                      }
                      required
                      autoComplete="off"
                      {...register("retailPR", { required: true })}
                      error={errors?.retailPR}
                      helperText={
                        errors?.retailPR ? "This field is required" : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <FormControl fullWidth>
                    
                        <>
                         
                          <Autocomplete
                           // disabled={isEditMode && true}

                            value={
                                    partTypeList.find(
                                      (item) => item.partTypeId === typeValueId
                                    ) || null
                                  }
                            size="small"
                            clearText='Clear'
                            onChange={(event, newValue, reason) => {

                              setTypeValue(newValue);
                              setTypeValueId(newValue?.partTypeId);

                            }}
                            //disableClearable
                            options={localStorage.getItem('partTypeListItem') ? JSON.parse(localStorage.getItem('partTypeListItem')) : ''}
                            getOptionLabel={(option) => option?.name ? option.name : ''}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Part Type *"
                                InputProps={{
                                  ...params.InputProps,
                                }}
                                {...register("partTypeId", {
                                  required: "This field is required",
                                })}
                                // error={Boolean(errors?.partTypeId?.message)}
                                // helperText={errors?.partTypeId?.message}
                              />
                            )}
                          />
                        </>
                     
                    </FormControl>
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <TextField
                      className="stepperFormInput"
                      name="spec"
                      label="Spare Specifications"
                      placeholder="Enter specifications"
                      fullWidth
                      required
                      size="small"
                      autoComplete="off"
                      defaultValue={formData.spec}
                      InputLabelProps={{ shrink: isEditMode && true }}
                      {...register("spec", {
                        required: "This field is required",
                        pattern: {
                          value: /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])[^\n]+$/,
                          message: "Field can not start with special characters",
                        },
                        maxLength: {
                          value: 200,
                          message: "Max length should be 200 only",
                        },
                      })}
                      error={Boolean(errors?.spec?.message)}
                      helperText={errors?.spec?.message}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <TextField
                      className="stepperFormInput"
                      name="dimension"
                      label="Spare Dimensions"
                      placeholder="Enter dimensions"
                      fullWidth
                      required
                      size="small"
                      InputLabelProps={{ shrink: isEditMode && true }}
                      autoComplete="off"
                     
                      {...register("dimension", {
                        required: "This field is required",
                        pattern: {
                          value: /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])[^\n]+$/,
                          message: "Field can not start with special characters",
                        },
                        maxLength: {
                          value: 50,
                          message: "Max length should be 50 only",
                        },
                      })}
                      error={Boolean(errors?.dimension?.message)}
                      helperText={errors?.dimension?.message}
                      defaultValue={""}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4}>
                   
                    <TextField
                      className="stepperFormInput"
                      name="packInfo"
                      label="Pack Information"
                      placeholder="Enter pack info."
                      fullWidth
                      InputLabelProps={{ shrink: isEditMode && true }}
                      required
                      size="small"
                      autoComplete="off"
                      {...register("packInfo", {
                        required: "This field is required",
                        pattern: {
                          value: /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])[^\n]+$/,
                          message: "Field can not start with special characters",
                        },
                        maxLength: {
                          value: 50,
                          message: "Max length should be 50 only",
                        },
                      })}
                      error={Boolean(errors?.packInfo?.message)}
                      helperText={errors?.packInfo?.message}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4}>
                  
                    <TextField
                      className="stepperFormInput"
                      name="appInstall"
                      label="Spare Application and Installation"
                      placeholder="Enter app and installation"
                      fullWidth
                      required
                      size="small"
                      autoComplete="off"
                      InputLabelProps={{ shrink: isEditMode && true }}
                      {...register("appInstall", {
                        required: "This field is required",
                        pattern: {
                          value: /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])[^\n]+$/,
                          message: "Field can not start with special characters",
                        },
                        maxLength: {
                          value: 50,
                          message: "Max length should be 50 only",
                        },
                      })}
                      error={Boolean(errors?.appInstall?.message)}
                      helperText={errors?.appInstall?.message}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <TextField
                      className="stepperFormInput"
                      name="spCare"
                      label="Spare Care"
                      placeholder="Enter spare care"
                      fullWidth
                      required
                      size="small"
                      autoComplete="off"
                      InputLabelProps={{ shrink: isEditMode && true }}
                      {...register("spCare", {
                        required: "This field is required",
                        pattern: {
                          value: /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])[^\n]+$/,
                          message: "Field can not start with special characters",
                        },
                        maxLength: {
                          value: 50,
                          message: "Max length should be 50 only",
                        },
                      })}
                      error={Boolean(errors?.spCare?.message)}
                      helperText={errors?.spCare?.message}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <FormControl fullWidth>
                      <InputLabel
                        id="demo-simple-select-label"
                        sx={{ marginTop: !isEditMode ? "-6px": "0px" }}
                      >
                        Spare Status *
                      </InputLabel>
                      <Select
                        className="stepperFormInput"
                        label="Spare Status*"
                        name="spareStatus"
                        fullWidth
                       
                        InputLabelProps={{ shrink: isEditMode && true }}
                         required
                        size="small"
                        value={spStatus || ""}  
                        
                        autoComplete="off"
                     
                        {...register("spareStatus", {
                          required: "This field is required",
                        })}
                        error={Boolean(errors?.spareStatus)}
                        helperText={errors?.spareStatus?.message}
                         onChange={(e) => setSpStatus(e.target.value)}  // 
                      >
                        {spareStatusList &&
                              spareStatusList.map((d) => {
                                return (
                                  <MenuItem
                                    native
                                    key={d.statusId}
                                    sx={{ width: "100%" }}
                                    value={d.statusId}
                                    size="small"
                                     
                                  >
                                    {d.name}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          <FormHelperText sx={{ color: "#d32f2f" }}>
                            {errors && errors?.spareStatus?.message}
                          </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    
                     <TextField
                          className="stepperFormInput"
                          name="warranty"
                          label="Spare Warranty"
                          placeholder="Enter Spare Warranty"
                          fullWidth
                          size="small"
                          type="number"
                          required
                          autoComplete="off"
                          InputLabelProps={{ shrink: isEditMode && true }}
                          onInput={(event) =>
                            event.target.value < 0
                              ? (event.target.value = "")
                              : event.target.value
                          }
                          {...register("warranty", { required: true })}
                          error={errors?.warranty}
                          helperText={
                            errors?.warranty ? "This field is required" : ""
                          }
                        />
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    

                    <TextField
                      className="stepperFormInput"
                      name="description"
                      label="description"
                      placeholder="Description"
                      fullWidth
                      required
                      size="small"
                      autoComplete="off"
                     // disabled={isEditMode && true}
                      InputLabelProps={{ shrink: isEditMode && true }}
                      {...register("description", {
                        required: "This field is required",
                        pattern: {
                          value: /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])[^\n]+$/,
                          message: "Field can not start with special characters",
                        },
                        maxLength: {
                          value: 2000,
                          message: "Max 2000 characters required",
                        },
                        minLength: {
                          value: 3,
                          message: "Minimum 3 characters required",
                        },
                      })}
                      error={Boolean(errors?.description?.message)}
                      helperText={errors?.description?.message}
                      onBlur={(e) => {
                        let str = e.target.value;
                        setValue("description", str.trim());
                       
                      }}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <TextField
                      className="stepperFormInput"
                      name="spareAcode"
                      label="Supplier Article Code"
                      placeholder="spareAcode"
                      fullWidth
                      
                      size="small"
                      autoComplete="off"
                      //disabled={isEditMode && true}
                      InputLabelProps={{ shrink: isEditMode && true }}
                      {...register("spareAcode", {
                       
                       pattern: {
                          value: /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])[^\n]+$/,
                          message: "Field can not start with special characters",
                        },
                        maxLength: {
                          value: 20,
                          message: "Max length should be 20 only",
                        },
                        minLength: {
                          value: 1,
                          message: "Min length should be 1 only",
                        },
                      })}
                      //maxLength={2000}
                      //minRows={3}
                      error={Boolean(errors?.spareAcode?.message)}
                      helperText={errors?.spareAcode?.message}
                      onBlur={(e) => {
                        let str = e.target.value;
                        setValue("spareAcode", str.trim());
                       
                      }}
                    />
                  </Grid>
                  <Grid container sx={{ mb: 2, marginLeft: "10px;" }}>
                    <Grid
                      item
                      xs={6}
                      sx={{
                        pr: 1,
                        color: "#003f93",
                        // fontWeight: "bold",
                        mb: 2,
                      }}
                    >
                      <NotificationsActiveIcon> </NotificationsActiveIcon> Send
                      Notification
                      <Checkbox
                        checked={sendNotification}
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </Grid>
                    {sendNotification ? (
                      <TextField
                        className="stepperFormInput"
                        label="Notification Description"
                        name="shortDesc"
                        fullWidth
                        required
                        size="small"
                        // InputLabelProps={{ shrink: true }}
                        autoComplete="off"
                        {...register("shortDesc", {
                          required: "This field is required",
                          pattern: {
                            value: /^(?![`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~ ])[^{}<>\n]+$/,
                            message: "Field can not start with special characters and exlclude {}<>",
                          },
                          maxLength: {
                            value: 2000,
                            message: "Max length should be 2000 only",
                          },
                          minLength: {
                            value: 3,
                            message: "Min length should be 3 only",
                          },
                        })}
                        error={Boolean(errors?.shortDesc?.message)}
                        helperText={errors?.shortDesc?.message}
                        onBlur={(e) => {
                          let str = e.target.value;
                          setValue("shortDesc", str.trim());
                         
                        }}
                      />
                    ) : null}
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Grid>
          <React.Fragment>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                p: 1,
                pl: 50,
                mt: 1,
              }}
            >
              <Button
                variant="contained"
                onClick={handleSubmit(onAddEditSpareSubmit)}
                sx={{ p: 1, mr: 1 }}
                className="button-primary-alt-contained"
              >
                Save
              </Button>
              <Button
                variant="contained"
                onClick={goBack}
                sx={{ p: 1, mr: 1 }}
                className="button-primary-alt-contained"
              >
                Cancel
              </Button>
              <Box sx={{ flex: "1 1 auto" }} />
            </Box>
          </React.Fragment>
        </Grid>
      </Grid>
      {/* </Dialog> */}
    </>
  );
};

export default AddEditSpare;
